<template>
    <div>
        <BarChart v-if="chartdata.loaded && loaded" :chartdata="chartdata" :options="options"/>
    </div>
</template>
<script>
    import BarChart from './chart-main.vue'
    import 'chartjs-plugin-datalabels'

    export default {
        name: 'chartBar',
        components: {
            BarChart
        },
        props: {
            resultados: {
                type: Array
            },
            chartdata: {
                type: Object
            }
        },
        data: () => ({
                loaded: false,
                options: {
                    plugins: {
                        datalabels: {
                            formatter: function (value, data = this) {
                                let text = value + data.dataset.medida
                                return text;
                            },
                            rotation: function (value) {
                                let grados = value.dataset.rotation
                                return grados;
                            },
                           color: 'black',
                        anchor: 'end',
                        align: 'top',
                            font: {
                                size: "14",
                                weight: 'bold',
                            }
                        }
                    },
                    legend: {
                        display: true,
                        position: 'top',
                        align: 'end',
                        labels: {
                            boxWidth: 0,
                            fontStyle: 'bold',
                            fontSize: 16,
                            fontColor: '#0F376E'
                        }
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
//                                drawBorder: true,
                                lineWidth: 2,
                                color: '#8D8E8E',
                                drawBorder: false,
                                zeroLineWidth: 3,
                                zeroLineColor: '#555555'
                            },
                            ticks: {
                                fontStyle: 'bold',
                                fontSize: 13,
                                fontColor: '#808080',
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                display: true,
//                                drawBorder: true,
                                lineWidth: 2,
                                color: '#9D9D9C',
                                drawBorder: false,
                                zeroLineWidth: 3,
                                zeroLineColor: '#555555'
                            },
                            ticks: {
                                fontStyle: 'bold',
                                fontSize: 13,
                                fontColor: '#626366',
                                beginAtZero: true,
                                min: 0
                            }
                        }],
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        ),
        created() {
            this.options.scales.yAxes[0].ticks.stepSize = this.chartdata.stepSize;
            this.options.scales.yAxes[0].ticks.max = this.chartdata.max;
//            this.options.scales.yAxes[0].ticks.min = this.chartdata.min;
            this.options.legend.display = this.chartdata.legend
//            this.options.scales.xAxes[0].gridLines.display = this.chartdata.xgridLines;
            if (this.chartdata.xgridLines === false) {
                this.options.scales.xAxes[0].gridLines.color = 'white';
            }
            this.loaded = true;
        },
        mounted() {

        },
        methods: {}
    }
</script>